import React from "react";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import { cn } from "./cn";

export default function Breadcrumbs({ items = [], className }) {
  return (
    <nav className={cn("flex items-center gap-1.5 text-xs text-muted", className)}>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <CaretRight size={12} className="text-faint" />}
            {it.to && !last ? (
              <Link to={it.to} className="transition-colors hover:text-ink">
                {it.label}
              </Link>
            ) : (
              <span className={cn(last && "font-medium text-ink")}>{it.label}</span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
